module.exports = __webpack_public_path__ + "img/table.edc5f2a3.png";